import React from "react";

const KilDashboardHome = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900">Bienvenue Stéphane</h1>
      <p className="text-gray-600 mt-1">Voici un résumé de votre magasin</p>
      
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900">Revenu total du mois</h3>
          <p className="text-3xl font-bold text-orange-600">250 000 FCFA</p>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900">Nombre de commandes</h3>
          <p className="text-3xl font-bold text-green-600">45</p>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900">Nombre de client</h3>
          <p className="text-3xl font-bold text-blue-600">99</p>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900">Produits actifs</h3>
          <p className="text-3xl font-bold text-purple-600">145</p>
        </div>
      </div>
    </div>
  );
};

export default KilDashboardHome;
